import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";
import { useEffectiveCompanyId } from "hooks/useEffectiveCompanyId";

export function useTelegramSubscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { user } = useAuth();

  const companyId = useEffectiveCompanyId();

  const fetchSubscribers = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);

    try {
      const res = await makeApiRequest(
        "get",
        apiRoutes.getTelegramSubscribers,
        { id: user.id, accessToken: user.accessToken },
        companyId
      );
      setSubscribers(res.data?.data ?? res.data ?? []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [companyId, user?.id, user?.accessToken]);

  useEffect(() => {
    fetchSubscribers();
  }, [fetchSubscribers]);

  return { subscribers, loading, error, refetch: fetchSubscribers };
}
